<template>
  <div class="row roomy align-center align-stretch">
    <div
      v-for="pack in iconPacks"
      :key="pack.name"
      class="all-icon-packs-listing column-12 tablet:column-6 laptop:column-4"
      style="--card-min-height: var(--icon-pack-card-min-height, 12rem)"
    >
      <site-link
        :to="$pack({ name: pack.name })"
        :class="`card header icon-pack-card icon-pack-card-${pack.name}`"
        :style="`
            background-clip: padding-box;
            background-image: url('/images/icons/packs/${pack.name}/${pack.thumbImage}');
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
          `"
      >
        <span class="sr-only">{{ pack.label }}</span>
      </site-link>
    </div>
    <div
      v-if="moreSoon"
      class="column"
    >
      <div
        class="card secondary with-border padding-xl muted align-center display-flex flex-column align-middle"
        style="--border-style: dashed; height: 100%"
      >
        <owa-question-mark-block
          block-hover-primary-color="var(--fa-navy)"
          block-size="2x"
        />
        <p class="margin-top-2xs tablet:size-sm">
          {{ ProPlusExclusiveIconPacksCount }} new Pro+ icon packs are available now, with new icon packs dropping regularly!
        </p>
        <p class="tag teal">More Icon Packs Coming Soon!</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { getIconPacksByCollection, getIconPack, getProPlusExclusiveIconPacks, getProPlusExclusiveIconPackObjects } from 'app/views/search/collections.js'

  export default {
    name: 'IconPackCards',

    props: {
      collectionName: {
        type: String
      },
      addBrands: {
        type: Boolean,
        default: false
      },
      moreSoon: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      activeMajorVersion() {
        return this.$releases.active.versionParts.major
      },

      ProPlusExclusiveIconPacksCount() {
        return getProPlusExclusiveIconPacks(this.activeMajorVersion).length
      },

      iconPacks() {
        let iconPacks
        if (this.collectionName === 'pro-plus-exclusive-collection') {
          iconPacks = getProPlusExclusiveIconPackObjects(this.activeMajorVersion)
        } else {
          iconPacks = getIconPacksByCollection(this.activeMajorVersion, this.collectionName)
        }

        if (this.addBrands && !iconPacks.find((p) => p.name === 'brands')) {
          iconPacks.push(getIconPack('brands', this.activeMajorVersion))
        }

        return iconPacks
      }
    },

    methods: {
      getPackIcon(pack) {
        return `${pack.iconPrefix} fa-${pack.iconName}`
      }
    }
  }
</script>
